import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { profileNethone } from 'nethone';

import { storeActive as activeStoreSelector } from 'ggApp/modules/store/selectors';
import LayoutComponentCheckoutTitle from 'ggApp/modules/layout/components/_checkout/title';
import LayoutComponentContainer from 'ggApp/modules/layout/components/container';
import LayoutComponentText from 'ggApp/modules/layout/components/text';
import LayoutComponentButton from 'ggApp/modules/layout/components/button';

import { transitionTo } from 'ggApp/modules/router/actions';
import { completeOrder as completeOrderAction } from 'ggApp/modules/order/actions';
import OrderComponentTable from 'ggApp/modules/order/components/Table';
import OrderComponentTableMobile from 'ggApp/modules/order/components/TableMobile';
import { Translator } from 'ggApp/modules/translator/components';
import { CheckoutBackToCartLink } from 'ggApp/modules/checkout/components';
import DisplayIf from 'ggApp/shared/components/viewport';

class CheckoutSummary extends Component {
    componentWillMount() {
        const { dispatch, order, user } = this.props;

        if (order.current_payment_source_id === null || !user.phone_verified) {
            dispatch(transitionTo('/checkout/payment'));
        }
    }

    completeOrder = (e) => {
        const { order, dispatch, checkoutAttemptReference } = this.props;
        e.preventDefault();

        dispatch(completeOrderAction(order.number, checkoutAttemptReference));

        profileNethone();
    };

    render() {
        const { order, orderFetching, storeCode, countryCode } = this.props;
        const includesSubscriptionProduct =
            order.items.filter((item) => item.minimum_term_months > 1).length > 0;

        const DesktopView = (
            <section>
                <LayoutComponentCheckoutTitle tk="ORDER_SUMMARY" />
                <LayoutComponentContainer>
                    <LayoutComponentText mini lightWeight>
                        {includesSubscriptionProduct && (
                            <Translator tk="SUBSCRIPTION_SUMMARY_NOTE" />
                        )}
                    </LayoutComponentText>
                    <OrderComponentTable
                        readOnly
                        order={order}
                        desktopColumnItem
                        buttonOnClick={this.completeOrder}
                        buttonLoading={orderFetching}
                        nextLink="/checkout/confirmation"
                        nextLinkTk="CONFIRM_CHECKOUT"
                        displaySummaryNote
                    />
                    <CheckoutBackToCartLink />
                </LayoutComponentContainer>
            </section>
        );

        const MobileView = (
            <section>
                <LayoutComponentCheckoutTitle tk="ORDER_SUMMARY" />
                <OrderComponentTableMobile readOnly order={order} displaySummaryNote />
                <LayoutComponentContainer>
                    <LayoutComponentText mini lightWeight noMarginTop usualMarginBottom center />
                    <LayoutComponentText mini lightWeight noMarginTop usualMarginBottom center>
                        <Translator
                            tk="SUMMARY_NOTE"
                            withValues={{
                                storeCode: countryCode?.toLowerCase(),
                            }}
                        />
                    </LayoutComponentText>
                    <CheckoutBackToCartLink />
                </LayoutComponentContainer>
                <LayoutComponentButton
                    fixedToBottom
                    noBorder
                    loading={orderFetching}
                    onClick={this.completeOrder}
                    to="/checkout/confirmation"
                    tk="CONFIRM_CHECKOUT"
                />
            </section>
        );

        return (
            <>
                <DisplayIf desktop largeDesktop widescreen>
                    {DesktopView}
                </DisplayIf>
                <DisplayIf mobile tablet>
                    {MobileView}
                </DisplayIf>
            </>
        );
    }
}

CheckoutSummary.propTypes = {
    order: PropTypes.shape({
        number: PropTypes.string,
        items: PropTypes.arrayOf(PropTypes.shape({})),
        current_payment_source_id: PropTypes.string,
    }),
    user: PropTypes.shape({
        phone_verified: PropTypes.bool,
    }),
    orderFetching: PropTypes.bool,
    dispatch: PropTypes.func.isRequired,
    storeCode: PropTypes.string.isRequired,
    countryCode: PropTypes.string.isRequired,
    checkoutAttemptReference: PropTypes.string.isRequired,
};

CheckoutSummary.defaultProps = {
    orderFetching: false,
    user: {},
    order: {},
};

export default connect((state, ownProps) => ({
    storeCode: activeStoreSelector(state, ownProps).code,
    countryCode: activeStoreSelector(state, ownProps).country_code,
}))(CheckoutSummary);
